function InitialiseHeaderListeners()
{
    var mobileNavIcons = document.querySelectorAll( ".js-menuToggle" );

    mobileNavIcons.forEach( function( mobileNavIcon )
    {
        mobileNavIcon.addEventListener( "click", HandleMobileNav );
    } );

    // Close hamburger menu on body click
    var body = document.querySelector( "body" );
    body.addEventListener( "click", HandleBodyClickForNav );   
}

function HandleBodyClickForNav( e )
{
    var el = e.target;
    if( !el.matches( '.js-menuToggle, .js-menuToggle *, .nav-main *' ) )
    {
        HideMobileNav();
    }
}

function HandleMobileNav( e )
{
    e.preventDefault();
    e.stopPropagation();

    var body                = document.querySelector( "body" );
    if( body.classList.contains( "nav--is-visible" ) )
    {
        HideMobileNav();
    }
    else
    {
        ShowMobileNav();
    }
}

function HideMobileNav()
{
    var navHamburger        = document.querySelector( ".nav-hamburger" );
    var body                = document.querySelector( "body" );
    var hamburger           = document.querySelector( "#hamburger-menu" );
    var transformClasses    = [ ".site-header", ".site-alert", ".bodyWrap", ".shop-bar" ];
    var scrollableElement   = document.querySelector('.nav-hamburger .nav-inner');

    if( body.classList.contains( "nav--is-visible" ) )
    {
        hamburger.classList.remove( "open" );
        body.classList.add( "nav--is-hiding" );
        body.classList.remove( "nav--is-visible" );

        var headerIcons = document.querySelectorAll( "header__icons a" );
        headerIcons.forEach( function( headerIcon )
        {
            headerIcon.removeAttribute( "tabindex" );
        } );    

        var navHamburgerButton = navHamburger.querySelector( "button" );
        var navHamburgerAnchor = navHamburger.querySelector( "a" );
        navHamburgerButton.setAttribute( "tabindex", "-1" );
        navHamburgerAnchor.setAttribute( "tabindex", "-1" );

        transformClasses.forEach( function( transformClass )
        {
            var els = document.querySelectorAll( transformClass );
            els.forEach( function( el )
            {
                var elStyle         = el.getAttribute( "style" );
                var elCssComponents = elStyle.split( ";" );
                var newelStyle      = "";

                elCssComponents.forEach( function( elCssComponent )
                {
                    if( !elCssComponent.includes( "transform" ) )
                    {
                        newelStyle + newelStyle + elCssComponent + ";";
                    }
                } );

                el.setAttribute( "style", newelStyle );
            } );
        } );

        // Reset timeout function
        if ( scrollLockTimeout ) 
        {
            clearTimeout( scrollLockTimeout );
        }
        // Unlock page scroll after drawer transition ends
        var scrollLockTimeout = setTimeout(function()
        {
            scrollLock.enablePageScroll( scrollableElement );
            body.classList.remove( "nav--is-hiding" );
        }, 500);

        window.removeEventListener( "resize.siteNav", HandleWindowResizeForNav );
    }
}

function ShowMobileNav()
{
    var navHamburger        = document.querySelector( ".nav-hamburger" );
    var navMenuWidth        = navHamburger.getBoundingClientRect().width + 'px';
    var body                = document.querySelector( "body" );
    var hamburger           = document.querySelector( "#hamburger-menu" );
    var transformClasses    = [ ".site-header", ".site-alert", ".bodyWrap", ".shop-bar" ];
    var scrollableElement   = document.querySelector('.nav-hamburger .nav-inner');

    // Lock page scroll immediately
    //not a fan of this...
    scrollLock.disablePageScroll( scrollableElement );

    hamburger.classList.add( "open" );
    body.classList.add( "nav--is-visible" );

    var headerIconsNotToggle = document.querySelectorAll( ".header__icons a:not(.js-menuToggle)" );
    headerIconsNotToggle.forEach( function( headerIconNotToggle )
    {
        headerIconNotToggle.setAttribute( "tabindex", "-1" );
    } );

    var navHamburgerButton = navHamburger.querySelector( "button" );
    var navHamburgerAnchor = navHamburger.querySelector( "a" );
    navHamburgerButton.removeAttribute( "tabindex" );
    navHamburgerAnchor.removeAttribute( "tabindex" );

    transformClasses.forEach( function( transformClass )
    {
        var els = document.querySelectorAll( transformClass );
        els.forEach( function( el )
        {
            var elStyle = el.getAttribute( "style" );
            elStyle     = elStyle + "transform: translateX(" + navMenuWidth + ");";
            el.setAttribute( "style", elStyle );
        } );
    } );

    window.addEventListener( "resize.siteNav", HandleWindowResizeForNav );
}

function HandleWindowResizeForNav( e )
{
    Reqs.debounce( function() 
    {
        var isHamburger = $('.site-header').hasClass('header--is-hamburger');
        if ( isHamburger ) {
            navMenuWidth = $('.nav-hamburger').width() + 'px';
            $transformElements.css({ 'transform': 'translateX(' + navMenuWidth + ')' });
        }
    } );
}

window.addEventListener( "DOMContentLoaded", function( e )
{
    InitialiseHeaderListeners();
} );